import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const papi = axios.create({ baseURL: API, withCredentials: true });
papi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("partner_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
}

export const mediaUrl = (uid, mid) => `${API}/partner/media/${uid}/${mid}`;
export default papi;
